import {
  addItem,
  removeItem,
  reorderItems,
} from '@/api/gen/quizset-folder-controller/quizset-folder-controller.gen';

import type { Folder } from '../../types/folder.types';
import { toFolder } from '../folder.adapters';

export const addFolderItem = async (
  id: string,
  quizsetId: string,
  confirmSourcePublication = false,
): Promise<Folder> =>
  toFolder((await addItem(id, { quizsetId, confirmSourcePublication })).data);

export const removeFolderItem = async (
  id: string,
  quizsetId: string,
): Promise<Folder> => toFolder((await removeItem(id, quizsetId)).data);

/**
 * 폴더 안 퀴즈 순서를 바꾼다 (`PATCH /quizset-folders/{id}/items/order`).
 *
 * ⚠️ `orderedQuizsetIds` 는 지금 폴더에 든 퀴즈 전부를 빠짐없이 한 번씩 담은 순열이어야 한다.
 * 부분 배열·중복을 보내면 서버가 `INVALID_INPUT` 으로 거절한다.
 */
export const reorderFolderItems = async (
  id: string,
  orderedQuizsetIds: string[],
): Promise<Folder> =>
  toFolder((await reorderItems(id, { orderedQuizsetIds })).data);
